export default __webpack_public_path__ + "static/media/snakerman.e4230723.png";